import clsx from 'clsx'
import styles from './styles.module.scss'

function InnerMsgWrapper({ children, type, className }) {
  return (
    <div className={clsx(styles.wrapper, className)} data-type={type}>
      {children}
    </div>
  )
}

export default InnerMsgWrapper
